"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createIkon;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function createIkon(Element) {
  const Ikon = _ref => {
    let {
      size = '1em',
      color = 'currentColor',
      ...props
    } = _ref;
    // Height alone is enough to control the size of the icon.
    // Fill is the attribute used to control color.
    const StyledElement = /*#__PURE__*/(0, _base.default)(Element, process.env.NODE_ENV === "production" ? {
      target: "e1c8ohbf0"
    } : {
      target: "e1c8ohbf0",
      label: "StyledElement"
    })("height:", size, ";fill:", color, ";max-width:", size, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9pY29ucy9pa29uLmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFReUMiLCJmaWxlIjoiLi4vLi4vc3JjL2ljb25zL2lrb24uanN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGNyZWF0ZUlrb24oRWxlbWVudCkge1xuICBjb25zdCBJa29uID0gKHsgc2l6ZSA9ICcxZW0nLCBjb2xvciA9ICdjdXJyZW50Q29sb3InLCAuLi5wcm9wcyB9KSA9PiB7XG4gICAgLy8gSGVpZ2h0IGFsb25lIGlzIGVub3VnaCB0byBjb250cm9sIHRoZSBzaXplIG9mIHRoZSBpY29uLlxuICAgIC8vIEZpbGwgaXMgdGhlIGF0dHJpYnV0ZSB1c2VkIHRvIGNvbnRyb2wgY29sb3IuXG4gICAgY29uc3QgU3R5bGVkRWxlbWVudCA9IHN0eWxlZChFbGVtZW50KWBcbiAgICAgIGhlaWdodDogJHtzaXplfTtcbiAgICAgIGZpbGw6ICR7Y29sb3J9O1xuICAgICAgbWF4LXdpZHRoOiAke3NpemV9O1xuICAgIGA7XG5cbiAgICByZXR1cm4gPFN0eWxlZEVsZW1lbnQgey4uLnByb3BzfSAvPjtcbiAgfTtcbiAgSWtvbi5kaXNwbGF5TmFtZSA9IEVsZW1lbnQubmFtZTtcbiAgSWtvbi5wcm9wVHlwZXMgPSB7XG4gICAgLyoqIFRoZSBpY29uIHNpemUsIGFzIGFueSB2YWxpZCBDU1MgdmFsdWUgKi9cbiAgICBzaXplOiBQcm9wVHlwZXMuc3RyaW5nLFxuICAgIC8qKiBUaGUgaWNvbiBjb2xvciwgYXMgYW55IHZhbGlkIENTUyBjb2xvciAqL1xuICAgIGNvbG9yOiBQcm9wVHlwZXMuc3RyaW5nLFxuICAgIC8qKiBBbiBvcHRpb25hbCAoZGVmYXVsdGluZykgaWNvbiB0aXRsZSBmb3IgaG92ZXJ0ZXh0ICovXG4gICAgdGl0bGU6IFByb3BUeXBlcy5zdHJpbmdcbiAgfTtcbiAgcmV0dXJuIElrb247XG59XG4iXX0= */"));
    return /*#__PURE__*/_react.default.createElement(StyledElement, props);
  };
  Ikon.displayName = Element.name;
  Ikon.propTypes = {
    /** The icon size, as any valid CSS value */
    size: _propTypes.default.string,
    /** The icon color, as any valid CSS color */
    color: _propTypes.default.string,
    /** An optional (defaulting) icon title for hovertext */
    title: _propTypes.default.string
  };
  return Ikon;
}